import { Box, Typography } from '@mui/material'
import type React from 'react'
import {
  Error as ErrorIcon,
  CheckCircle as CheckCircleIcon
} from '@mui/icons-material'
import { isEmpty } from 'lodash'

import { color } from 'config/color'

interface AlertBannerProps {
  type: 'info' | 'warning' | 'error' | 'success'
  message: string
  isVisible: boolean
  children?: any
}

export const AlertBanner: React.FC<AlertBannerProps> = ({
  isVisible,
  type,
  message,
  children
}) => {
  return (
    <>
      {isVisible && (
        <Box
          display="flex"
          justifyContent="flex-start"
          alignItems="center"
          bgcolor={color.secondary.dark[50]}
        >
          {type === 'warning' && (
            <Box bgcolor={color.warning[500]} p={0.75}>
              <ErrorIcon
                sx={{
                  color: color.white,
                  fontSize: 16
                }}
              />
            </Box>
          )}

          {type === 'success' && (
            <Box bgcolor={color.success[600]} p={0.75}>
              <CheckCircleIcon
                sx={{
                  color: color.white,
                  fontSize: 16
                }}
              />
            </Box>
          )}

          {type === 'error' && (
            <Box bgcolor={color.error[600]} p={0.75}>
              <ErrorIcon
                sx={{
                  color: color.white,
                  fontSize: 16
                }}
              />
            </Box>
          )}

          <Box pl={1}>
            {isEmpty(message)
            ? (
              children
            )
            : (
              <Typography
                fontSize={12}
                fontWeight={400}
                color={color.grey[700]}
              >
                {message.includes('<')
                ? (
                  <Box
                    sx={{
                      a: {
                        color: color.primary[600]
                      }
                    }}
                  >
                    <span dangerouslySetInnerHTML={{ __html: message }} />
                  </Box>
                )
                : (
                  message
                )}
              </Typography>
            )}
          </Box>
        </Box>
      )}
    </>
  )
}
